import cx from 'classnames'

export default function({ device, onClick }) {
  const classNames = cx('crossButton', { device: !!device }, device)

  return <button type="button" className={ classNames } onClick={ onClick }>×</button>
}
